// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root__3xpBF","bucket":"Drawer_bucket__1vBTO","overlay":"Drawer_overlay__21McC","icon":"Drawer_icon__3PQvL"};